<template>
  <section class="gridClass mb-8">
    <!-- for desktop -->
    <section v-if="isDesktop" class="just-desktop">
      <slot name="title" />
      <div
        v-if="!slots.title && data.title"
        class="font-bold text-center text-xl laptop:text-2xl"
      >
        {{ data.title }}
      </div>
      <div class="flex p-10 relative shadow-lg h-full">
        <div class="flex">
          <div v-if="data.off" class="off">
            <div>%{{ data.off }}</div>
            <div class="-mt-2">OFF</div>
          </div>
        </div>
        <div class="label-price">{{ data.label }}</div>
        <div class="flex-grow flex flex-col pe-10 !w-[80%]">
          <slot name="subTitle" />
          <div v-if="!slots.subTitle && data.subTitle" class="font-bold mb-2">
            {{ data.subTitle }}
          </div>
          <p class="text-sm mb-4 text-justify">
            {{ data.desc }}
          </p>
          <template
            v-if="
              data.options &&
              Array.isArray(data.options) &&
              data.options.length > 0
            "
          >
            <div
              class="flex items-center text-sm mb-1"
              v-for="item in data.options"
              :key="item.id"
            >
              <IconLightTik class="stroke-blue-500 scale-100 ml-2 h-6 mt-2" />
              <p>{{ item.text }}</p>
            </div>
          </template>
          <template
            v-if="
              data.featuers &&
              Array.isArray(data.featuers) &&
              data.featuers.length > 0
            "
          >
            <div
              class="flex items-center text-sm mb-1"
              v-for="item in data.featuers"
              :key="item.id"
            >
              <IconTik class="fill-blue-700 scale-75 laptop:scale-100" />
              <p>{{ item.text }}</p>
            </div>
          </template>
        </div>
        <div class="flex-grow border-e border-blue-500 me-10" />
        <div class="!w-[20%] self-center">
          <slot />
        </div>
      </div>
    </section>
    <!-- for mobile -->
    <section v-else class="just-mobile">
      <div class="text-center font-bold text-xl mb-10">{{ data.title }}</div>
      <div class="flex relative shadow p-6">
        <div class="">
          <div class="flex">
            <div v-if="data.off" class="off">
              <div>%{{ data.off }}</div>
              <div class="-mt-2">OFF</div>
            </div>
          </div>
          <div class="label-price">{{ data.label }}</div>
          <div class="text-right">
            <h5 class="font-bold mb-6">
              {{ data.subTitle }}
            </h5>
            <p class="text-xs laptop:text-base mb-3">
              {{ data.desc }}
            </p>
            <template
              v-if="
                data.options &&
                Array.isArray(data.options) &&
                data.options.length > 0
              "
            >
              <div
                class="flex py-1"
                v-for="item in data.options"
                :key="item.id"
              >
                <div class="">
                  <IconLightTik class="stroke-blue-500 scale-100 ml-2 h-6" />
                </div>
                <p class="text-xs laptop:text-base">{{ item.text }}</p>
              </div>
            </template>
            <template
              v-if="
                data.featuers &&
                Array.isArray(data.featuers) &&
                data.featuers.length > 0
              "
            >
              <div
                class="flex py-4 w-full"
                v-for="item in data.featuers"
                :key="item.id"
              >
                <div class="">
                  <IconLightTik class="stroke-blue-500 scale-100 ml-2 h-6" />
                </div>
                <p class="text-xs laptop:text-base">{{ item.text }}</p>
              </div>
            </template>
          </div>
          <hr class="w-full bg-blue-500 mt-2" />
          <div class="p-4">
            <slot />
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script setup>
import { useSlots } from "vue";

defineProps({
  data: Object,
});

const { isDesktop } = useScreen();

const slots = useSlots();
</script>
